import { FC } from 'react';
import cx from 'classnames';

type TVerticalSeparatorProps = {
  className?: string;
};
export const VerticalSeparator: FC<TVerticalSeparatorProps> = ({ className }) => (
  <div className={cx('h-4 min-w-[1px] bg-gray-400', [className])} />
);
